export const testimonials = [
  {
    text: "I was skeptical about ordering from Vanish Candles, but after trying their Amber Woods scent, I’m absolutely hooked. The warm, comforting aroma lingers without being overpowering. My guests always comment on how inviting my living room feels now!",
    author: "— Alice S.",
  },
  {
    text: "Midnight Oak is my go-to for unwinding at night. It’s like stepping into a cozy forest at dusk—just enough smokiness to keep things interesting. I never realized a candle could create such a peaceful vibe!",
    author: "— Sam S.",
  },
  {
    text: "Dark Bourbon from Vanish Candles has totally changed my idea of what a candle can do. It’s rich, smooth, and makes me feel like I’m relaxing in a classy bourbon lounge. Perfect for those mellow evenings at home!",
    author: "— Martin D.",
  },
  {
    text: "Coastal Drift is perfect for freshening up my home with a crisp, ocean breeze vibe. It instantly reminds me of salty seaside air. Can’t wait to try the other scents from Vanish Candles!",
    author: "— Rebecca R.",
  },
  {
    text: "I love the packaging and minimal aesthetic of Vanish Candles almost as much as their fragrances. Their Fireside Ember candle basically teleports me to a mountain cabin—so cozy!",
    author: "— Devon A.",
  },
];
